var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h100v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5F6368",
    d: "M48.342 20.087v7.032H52.7c1.039 0 1.897-.347 2.576-1.041.697-.693 1.046-1.52 1.046-2.475 0-.938-.349-1.754-1.046-2.448-.679-.712-1.537-1.07-2.576-1.07h-4.358v.002zm0 9.508v8.157H45.74v-20.14h6.905c1.754 0 3.244.582 4.47 1.744 1.246 1.162 1.868 2.578 1.868 4.247 0 1.707-.622 3.132-1.867 4.275-1.208 1.144-2.7 1.715-4.471 1.715h-4.302v.002zm13.271 3.937c0 .675.288 1.238.864 1.688.575.45 1.25.675 2.023.675 1.094 0 2.07-.403 2.928-1.209.859-.806 1.287-1.753 1.287-2.84-.811-.638-1.943-.956-3.395-.956-1.058 0-1.94.254-2.646.76-.707.506-1.06 1.132-1.06 1.882m3.368-10.013c1.924 0 3.442.511 4.557 1.533 1.112 1.023 1.668 2.424 1.668 4.205v8.495h-2.49v-1.913h-.113c-1.076 1.575-2.51 2.363-4.301 2.363-1.528 0-2.808-.45-3.835-1.35-1.028-.9-1.542-2.026-1.542-3.376 0-1.426.542-2.559 1.627-3.402 1.085-.844 2.532-1.267 4.343-1.267 1.546 0 2.82.281 3.82.844v-.592c0-.9-.36-1.663-1.076-2.292a3.7 3.7 0 00-2.518-.942c-1.453 0-2.603.61-3.452 1.83l-2.293-1.436c1.264-1.8 3.132-2.7 5.605-2.7m20.515.45l-8.688 19.858h-2.688l3.226-6.948-5.716-12.91h2.83l4.131 9.901h.057l4.018-9.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M37.823 27.836c0-.815-.07-1.6-.2-2.353h-10.98v4.457h6.288a5.356 5.356 0 01-2.325 3.517v2.895h3.753c2.198-2.016 3.464-4.994 3.464-8.516"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M26.643 39.145c3.142 0 5.787-1.025 7.716-2.793l-3.753-2.895c-1.045.699-2.39 1.107-3.963 1.107-3.037 0-5.615-2.035-6.536-4.777H16.24v2.982a11.65 11.65 0 0010.403 6.376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FABB05",
    d: "M20.107 29.787a6.916 6.916 0 010-4.43v-2.98H16.24A11.454 11.454 0 0015 27.572c0 1.869.448 3.634 1.24 5.196l3.867-2.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E94235",
    d: "M26.643 20.58c1.715 0 3.253.587 4.466 1.737v.001l3.323-3.303C32.414 17.148 29.782 16 26.642 16a11.65 11.65 0 00-10.402 6.376l3.867 2.982c.921-2.742 3.499-4.777 6.536-4.777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.586c4df2d676cff792d2381cd5e01ad1.svg";
export { ForwardRef as ReactComponent };